import React, { Component } from "react";

//Assets
import box4 from "../Assets/box4.svg";

class Exchanges extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cellClickStatus: false,
      exchangesData: [
        {
          title: "Binance",
          tradeVol: "$ 88,427,647,472",
          desc: "Binance is the world's leading blockchain ecosystem, with a product suite that includes the largest digital asset exchange. Our Mission is to be the infrastructure service provider in crypto. Our platform is trusted by millions worldwide, and features an unmatched portfolio of financial product offerings",
          openStatus: false,
          market: "1709",
          changes: "-8.71",
        },
        {
          title: "OKX",
          tradeVol: "$ 26,268,553,622",
          desc: "OKX is a world-leading cryptocurrency and Bitcoin exchange that provides hundreds of trading pairs for spot and derivatives. We are the leader among cryptocurrency exchanges, with daily trading volume and open interest of Bitcoin futures reaching $1.65 billion and $1.1 billion, respectively.",
          openStatus: false,
          market: "905",
          changes: "-6.88",
        },
        {
          title: "Coinbase Exchange",
          tradeVol: "$ 2,731,671,786",
          desc: "Coinbase is one of the most liquid regulated crypto spot exchanges in the world. Get low cost of execution leveraging a dynamic fee structure for high-volume trading.",
          openStatus: false,
          market: "526",
          changes: "5.90",
        },
        {
          title: "Bybit",
          tradeVol: "$ 13,862,097,751",
          desc: "Bybit is a cryptocurrency exchange established in March 2018 to offer a professional platform where crypto traders can find an ultra-fast matching engine, excellent customer service and multilingual community support.",
          openStatus: false,
          market: "495",
          changes: "90.06",
        },
        {
          title: "Ftx",
          tradeVol: "$ 15,776,327,175",
          desc: "FTX Exchange is a leading centralized cryptocurrency exchange specializing in derivatives and leveraged products. Founded in 2018 by MIT graduate and former Jane Street Capital international exchange-traded funds trader Sam Bankman-Fried, FTX offers a range of trading products, including derivatives, options, volatility products, and leveraged tokens. It also provides spot markets in over 100 cryptocurrency trading pairs such as BTC/USDT, ETH/USDT, XRP/USDT, and its native token FTT/USDT.",
          openStatus: false,
          market: "698",
          changes: "3.42",
        },
        {
          title: "Uniswap V3",
          tradeVol: "$ 1,469,858,628",
          desc: "Uniswap is a protocol on Ethereum for swapping ERC20 tokens without the need for buyers and sellers to create demand.",
          openStatus: false,
          market: "1083",
          changes: "2.13",
        },
        {
          title: "Huobi Global",
          tradeVol: "$ 4,832,569,340",
          desc: "Huobi Global is one of the leading crypto exchanges in the world. You can buy and sell Bitcoin&Ethereum and other cryptocurrencies quickly and easily.",
          openStatus: false,
          market: "1068",
          changes: "-10.67",
        },
        {
          title: "Crypto.com",
          tradeVol: "$ 1,440,884,549",
          desc: "Crypto.com is an online platform that supports investors to invest in cryptocurrencies. The digital asset exchange organisation offers several cryptocurrency products and services, meaning an investor can buy, sell, trade, spend, store, earn, loan cash and even pay bills with cryptocurrencies using Crypto.com. ",
          openStatus: false,
          market: "510",
          changes: "-8.61",
        },
        {
          title: "KuCoin Futures",
          tradeVol: "$ 1,774,099,536",
          desc: "KuCoin Futures is the easiest, safest, most transparent, and user friendly Bitcoin Litecoin trading platform, offering cryptocurrency perpetual contracts.",
          openStatus: false,
          market: "132",
          changes: "25.05",
        },
        {
          title: "Pancake Swap",
          tradeVol: "$ 182,000,997",
          desc: "PancakeSwap is a decentralized exchange native to BNB Chain. In other words, it shares some similarities with established platforms like UniSwap in that users can swap their coins for other coins without the input of middleman services.",
          openStatus: false,
          market: "5913",
          changes: "31.95",
        },
        {
          title: "Gate.io",
          tradeVol: "$ 1,358,245,122",
          desc: "Gate.io protects your funds with both. centralized and decentralized methods. It is also the first exchange to invest millions in security and law funds to add extra protection for your assets. Efficient trading and instant deposit/withdrawal.",
          openStatus: false,
          market: "2680",
          changes: "77.89",
        },
        {
          title: "Mexc Global",
          tradeVol: "$ 2,848,591,119",
          desc: " MEXC Global is known as the exchange of high performance and mega transaction matching technology. The team at MEXC Global are some of the first movers and pioneers of financial and blockchain technology.",
          openStatus: false,
          market: "1875",
          changes: "231.34",
        },
        {
          title: "Karken",
          tradeVol: "$ 747,332,366",
          desc: "Kraken is more than just a Bitcoin trading platform. Come see why our cryptocurrency exchange is the best place to buy, sell, trade and learn about crypto.",
          openStatus: false,
          market: "585",
          changes: "76.87",
        },
      ],
    };
  }

  /* This function helps to open the cell whose openstatus is true
   */
  openTableCell = (index) => {
    var data = this.state.exchangesData;

    for (var i = 0; i < data.length; i++) {
      if (index !== i) {
        data[i].openStatus = false;
      }
    }
    data[index].openStatus = !data[index].openStatus;
    this.setState({ exchangesData: data });
  };

  tableData(data, index) {
    return (
      <tbody
        className="Exchanges_TableCell"
        key={index}
        onClick={() => this.openTableCell(index)}
      >
        {/*}  <tbody> */}
        <tr className="Exchanges_TableData">
          <td>{data.title}</td>
          <td>{data.tradeVol}</td>
          <td>{data.market}</td>
          <td className={data.changes >= 0 ? "green" : "red"}>
            {data.changes} %
          </td>
        </tr>
        <tr className={data.openStatus ? "Exchanges_Info active" : "inactive"}>
          <td className="Exchanges_TableLine"></td>
          <td>{data.desc}</td>
        </tr>
      </tbody>
    );
  }

  render() {
    // local var
    var index = -1;

    return (
      <div className="Exchanges">
        <div className="Exchanges_ExchangesOverFlow">
          <div className="Exchanges_Title">Exchanges</div>

          {/* Exchanges Table Block */}
          <div className="Exchanges_TableBlock">
            <table className="Exchanges_Table">
              <thead>
                <tr className="Exchanges_TableTitle">
                  <th>Exchanges</th>
                  <th>24th Trade Volume</th>
                  <th>Markets</th>
                  <th>Changes</th>
                </tr>
              </thead>
              {this.state.exchangesData !== undefined ? (
                this.state.exchangesData.map((data) => {
                  if (data !== undefined) {
                    index = index + 1;
                    return (
                      <React.Fragment key={index}>
                        {this.tableData(data, index)}
                      </React.Fragment>
                    );
                  }
                  return <></>;
                })
              ) : (
                <div></div>
              )}
            </table>
          </div>
        </div>

        <div className="CurrencyDetails_bg">
          <img src={box4} alt="" className="CurrencyDetails_box" />
          <div className="CurrencyDetails_cir"></div>
          <div className="CurrencyDetails_cir2"></div>
        </div>
      </div>
    );
  }
}

export default Exchanges;
